import { NotifyHelper } from "../../../helpers/toast";
import { eAccQuyDoiTyGiaActionsObj } from "../../action-types/category/IAccQuyDoiTyGiaActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const quyDoiTyGiaActions = {
  ...generateActions(eAccQuyDoiTyGiaActionsObj, "QUY_DOI_TY_GIA"),
  ...generateActionForKey(
    eAccQuyDoiTyGiaActionsObj,
    "QUY_DOI_TY_GIA",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    },
  ),
  ...generateActionForKey(
    eAccQuyDoiTyGiaActionsObj,
    "QUY_DOI_TY_GIA",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eAccQuyDoiTyGiaActionsObj,
    "QUY_DOI_TY_GIA",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    },
  ),
  ...generateActionForKey(
    eAccQuyDoiTyGiaActionsObj,
    "QUY_DOI_TY_GIA",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
};
